import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ngxCsv } from 'ngx-csv/ngx-csv';

type UserRawData = {
    email: string[];
    firstName: string[];
    lastName: string[];
};

type DataTableUser = {
    index: number;
    name: string;
    email: string;
};

class UserFilter {
    constructor(private users: DataTableUser[], private searchTerm: string) {}

    private isSubstring(string: string, substring: string): boolean {
        const stringProcessed: string = string.toLowerCase().trim();
        const substringProcessed: string = substring.toLowerCase().trim();

        return stringProcessed.includes(substringProcessed);
    }

    private vetUser(user: DataTableUser, searchTerm: string): boolean {
        return (
            this.isSubstring(user.name, searchTerm) ||
            this.isSubstring(user.email, searchTerm)
        );
    }

    public filterUsers(): DataTableUser[] {
        const filteredUsers: DataTableUser[] = this.users.filter(
            (user: DataTableUser) => {
                return this.vetUser(user, this.searchTerm);
            }
        );
        return filteredUsers;
    }
}

class DataProcessor {
    constructor(private data: UserRawData) {}

    private createFullName(index: number): string {
        return `${this.data.firstName[index]} ${this.data.lastName[index]}`;
    }

    public transformRawData(): DataTableUser[] {
        const userData: DataTableUser[] = [];
        for (let i = 0; i < this.data.email.length; i++) {
            const person = {
                index: i + 1,
                name: this.createFullName(i),
                email: this.data.email[i],
            };
            userData.push(person);
        }
        return userData;
    }
}

@Component({
    selector: 'app-view-users',
    templateUrl: './view-users.component.html',
    styleUrls: ['./view-users.component.scss'],
})
export class ViewUsersComponent implements OnInit {
    displayedColumns: string[] = ['index', 'name', 'email'];
    USER_DATA: DataTableUser[] = [];
    dataSource: DataTableUser[] = [];

    constructor(
        public dialogRef: MatDialogRef<ViewUsersComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: UserRawData
    ) {}

    updateUserTable(userData: DataTableUser[]): void {
        this.dataSource = userData;
    }

    ngOnInit(): void {
        const dataProcessor = new DataProcessor(this.data);
        this.USER_DATA = dataProcessor.transformRawData();
        this.updateUserTable(this.USER_DATA);
    }

    onInputChange(event: any): void {
        const inputText = event.target.value;
        const filter: UserFilter = new UserFilter(this.USER_DATA, inputText);

        if (inputText.length > 0) {
            const filteredUsers: DataTableUser[] = filter.filterUsers();
            this.updateUserTable(filteredUsers);
        } else {
            this.updateUserTable(this.USER_DATA);
        }
    }

    export(): void {
        const data = this.dataSource.map((user) => ({
            name: user.name,
            email: user.email,
        }));

        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Name', 'Email'],
            useBom: false,
            removeNewLines: true,
        };

        new ngxCsv(data, 'Report', options);
    }

    close(): void {
        this.dialogRef.close();
    }
}
